module.exports = __webpack_public_path__ + "img/index-welcome-image2.5737c1bc.png";